var render, staticRenderFns
import script from "./total_adjust.vue?vue&type=script&lang=js&"
export * from "./total_adjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfeb812')) {
      api.createRecord('bbfeb812', component.options)
    } else {
      api.reload('bbfeb812', component.options)
    }
    
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_manage/form/total_adjust.vue"
export default component.exports